import {
  CategoryTableData,
  CategoryTableRow,
  CategoryResponse,
  CategoryApiData,
} from '@app/models/pre_clearance_catergories/CategoryResponse';
import { post, get } from './http.api';
import { Parameters } from '@app/models/Parameters';
import { CategoryRequest } from '@app/models/pre_clearance_catergories/CategoryRequest';

export const getCategoryTableData = async (parameters: Parameters): Promise<CategoryTableData> => {
  try {
    const { data, status } = await get<any>('pre_clearance_categories', { params: parameters }, true);
    console.log(`Status: ${status}`, `Data:`, data);

    const categories: CategoryTableRow[] = data?.pre_clearance_categories?.data?.map((categoryData: any) => ({
      id: categoryData.id,
      code: categoryData.code,
      name: categoryData.name,
      description: categoryData.description,
      status: categoryData.status,
      parent: categoryData.parent_id,
    }));

    return {
      data: categories,
      status_options: Array.isArray(data.status_options) ? data.status_options : [],
      pagination: {
        current: data.pre_clearance_categories.current_page,
        pageSize: data.pre_clearance_categories.per_page,
        total: data.pre_clearance_categories.total,
      },
    };
  } catch (error: any) {
    console.error('Error fetching Pre-Clearance Categories:', error);
    throw error;
  }
};

export const getAllCategories = async (): Promise<CategoryResponse> => {
  try {
    const { data, status } = await get<CategoryResponse>('pre_clearance_categories', undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getCategoryById = async (id: number): Promise<CategoryResponse> => {
  try {
    const { data, status } = await get<CategoryResponse>(`pre_clearance_categories/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const storeCategory = async (categoryData: CategoryRequest) => {
  try {
    const response = await post<any>('pre_clearance_categories/create', categoryData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const createCategory = async (): Promise<CategoryApiData> => {
  try {
    const { data, status } = await get<CategoryApiData>('pre_clearance_categories/create', undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const showCategory = async (id: number) => {
  try {
    const { data, status } = await get<CategoryApiData>(`pre_clearance_categories/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const editCategory = async (id: number) => {
  try {
    const { data, status } = await get<CategoryApiData>(`pre_clearance_categories/${id}/edit`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const updateCategory = async (id: number, updateData: CategoryRequest) => {
  try {
    const { data, status } = await post<CategoryRequest>(
      `pre_clearance_categories/${id}/edit`,
      updateData,
      undefined,
      true,
    );
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};
